<ppl-dialog
  width="500px"
  title="QR code sign in"
  i18n-title="@@QR_code_sign_in"
  [loading]="(data$ | async).state === AsyncState.FETCHING"
  [actionVisible]="false"
  cancelLabel="close"
  (cancel)="onClose()">
  <div class="content">
    <ol class="instructions">
      <li i18n="@@Open_Coevera_mobile_app">Open Coevera mobile app</li>
      <li i18n="@@AccountsSelectSignInUsingQRCode">Select "Sign in using QR Code"</li>
      <li i18n="@@Point_your_device_at_the_QR_code_to_sign_in_to_your_mobile_device">Point your device at the QR code to sign in to your mobile device</li>
    </ol>

    @if (!(success$ | async)) {
      <div class="data">
        @if (data$ | async; as data) {
          @if (data.state === AsyncState.FETCHED) {
            <ppl-qr-code
              [value]="data.value.code"
              [size]="200"></ppl-qr-code>
            <div class="timer">
              {{ activationExpiration$ | async }}
            </div>
          }
          @if (data.state === AsyncState.ERROR) {
            <ng-container i18n="@@Error">Error</ng-container>
          }
        }
      </div>
    }
    @if (success$ | async) {
      <div class="data">
        <ppl-icon
          svgIcon="check-mark-ring-success"
          width="148px"
          height="148px"></ppl-icon>
        <div
          class="success-title"
          i18n="@@Sign_In_successful">
          Sign In successful
        </div>
        <div
          class="success-description"
          i18n="@@You_have_successfully_signed_into_Coevera_mobile_app._You_can_close_this_window.">
          You have successfully signed into Coevera mobile app. You can close this window.
        </div>
      </div>
    }
  </div>
</ppl-dialog>
